// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-text-editor-insert-embed-code-dialog .content-wrapper {
  padding: 16px;
}

/*
.insert-embed-code-operation-overlay-small .modal-dialog
{
  width: 320px;


  .embed-block
  {
    margin-top: 10px;
  }

  .content-header
  {
    margin-bottom: 5px;
  }

  .embed-url-message
  {
    text-align: right;
    color: var(--fi-color-light);
    font-size: 90%;
    margin-top: 5px;
  }
}
*/`, "",{"version":3,"sources":["webpack://./Source/app/shared/text-editor/text-editor-insert-embed-code-dialog/text-editor-insert-embed-code-dialog.component.scss"],"names":[],"mappings":"AACI;EACI,aAAA;AAAR;;AAGA;;;;;;;;;;;;;;;;;;;;;;;;CAAA","sourcesContent":[".fi-text-editor-insert-embed-code-dialog {\r\n    .content-wrapper {\r\n        padding: 16px;\r\n    }\r\n}\r\n/*\r\n.insert-embed-code-operation-overlay-small .modal-dialog\r\n{\r\n  width: 320px;\r\n\r\n\r\n  .embed-block\r\n  {\r\n    margin-top: 10px;\r\n  }\r\n\r\n  .content-header\r\n  {\r\n    margin-bottom: 5px;\r\n  }\r\n\r\n  .embed-url-message\r\n  {\r\n    text-align: right;\r\n    color: var(--fi-color-light);\r\n    font-size: 90%;\r\n    margin-top: 5px;\r\n  }\r\n}\r\n*/\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
